const getSideBarTitleMessageId = ({ pricingErrorCode }: { pricingErrorCode: number | null }): string => {
    return pricingErrorCode === null ? 'selectDatesAndGuests' : 'notAvailable'
}

export default getSideBarTitleMessageId
